export default {"src":"/_next/static/media/doge.517f3801.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};